import { useRef } from "react"

import Style from "./style"

import MainHeader from "widget/MainHeader"

import useGetMy from "entity/admin/useGetMy"
import usePutMy from "entity/admin/usePutMy"

import ITStyle from "shared/style/inputTableStyle"

const MyAdminEdit = () => {
    const nameRef = useRef()
    const pwRef = useRef()

    const [myStoreData] = useGetMy()
    const [putStore] = usePutMy(nameRef, pwRef)

    const btnList = [
        {
            "label": "저장",
            "clickEvent": () => putStore()
        }
    ]

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList} />

            <ITStyle.TableDiv>
                <ITStyle.TableElement>
                    <h2>이름<span>*</span></h2>
                    <input ref={nameRef} placeholder="40글자 이하" defaultValue={myStoreData?.data?.name} />
                </ITStyle.TableElement>
                <ITStyle.TableElement>
                    <h2>비밀번호<span>*</span></h2>
                    <input type="password" ref={pwRef} placeholder="20글자 이하 | 한글과 영문만 가능" defaultValue={myStoreData?.data?.password} />
                </ITStyle.TableElement>
            </ITStyle.TableDiv>

        </Style.Wrapper>
    )
}

export default MyAdminEdit